import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { get, upperFirst } from 'lodash';

import CardListItem from '@dashboard/components/CardListItem';
import TableRowElement from '@dashboard/components/TableRowElement';

import getPriceLabel from '@dashboard/services/translation/getPriceLabel';
import PaymentStatusBadge from '../PaymentItem/PaymentStatusBadge';

const propTypes = {
  payment: PropTypes.object.isRequired,
};

const BookingItem = ({ payment, options = {} }) => {
  const isCompact = options.appearance === 'compact';

  // if abandoned and status = draft we show as abandoned
  // const isAbandoned = payment.isAbandoned && payment.status === 'draft';
  return (
    <CardListItem
      href={payment.status === 'draft' ? undefined : `/orders/bookings/${payment._id}`}
    >
      {!options.hideCustomer && (
        <TableRowElement size={isCompact ? 'xl' : '3xl'}>
          <div className="font-medium">
            {(payment.customer && get(payment, 'customer.email')) || get(payment, 'customerEmail') || '–'}
          </div>
          <div className="text-sm text-gray-500">
            {payment.customer && get(payment, 'customer.name')}
          </div>
        </TableRowElement>
      )}

      <TableRowElement size={isCompact ? 'small' : 'large'} className="font-medium">
        {getPriceLabel({
          amount: payment.amount,
          currency: payment.currency,
        })}
      </TableRowElement>

      {!options.hidePaymentLink && (
        <TableRowElement size={isCompact ? 'xl' : '4xl'}>
          {get(payment, 'page.name') || '—'}
        </TableRowElement>
      )}

      {!options.hidePageType && (
        <TableRowElement size="medium" align="right">
          {payment.page?.type ? upperFirst(payment.page?.type) : '–'}
        </TableRowElement>
      )}

      <TableRowElement size="xl" align={options.hidePageType ? 'right' : ''}>
        {format(new Date(get(payment, 'createdAt')), 'd MMM, yyyy, HH:mm')}
      </TableRowElement>

      {!options.hideStatus && (
        <>
          {(() => {
            const isCanceledOrArchived =
              payment.orderStatus === 'canceled' || payment.orderStatus === 'archived';
            const isRefunded = payment.status === 'refunded' || payment.status === 'partial_refund';
            const isRecovered = payment.isAbandoned && (payment.status === 'paid' || payment.status === 'partially_paid' || payment.status === 'active');

            /** Show both badges when canceled + refunded */
            if (payment.orderStatus === 'canceled' && isRefunded) {
              return (
                <TableRowElement size="medium" className="gap-1">
                  <PaymentStatusBadge status={payment.orderStatus} livemode={payment.livemode} />
                  <PaymentStatusBadge
                    status={payment.status}
                    livemode={payment.livemode}
                    error={payment.paymentError}
                    isAbandoned={payment.isAbandoned}
                  />
                </TableRowElement>
              );
            }

            /** Show both badges when recovered (actual status + recovered) */
            if (isRecovered) {
              return (
                <TableRowElement size="medium" className="gap-1">
                  <PaymentStatusBadge
                    status={payment.status}
                    livemode={payment.livemode}
                    error={payment.paymentError}
                  />
                  <PaymentStatusBadge status="recovered" livemode={payment.livemode} />
                </TableRowElement>
              );
            }

            if (isCanceledOrArchived && !isRefunded) {
              return (
                <TableRowElement size="medium">
                  <PaymentStatusBadge status={payment.orderStatus} livemode={payment.livemode} />
                </TableRowElement>
              );
            }

            return (
              <TableRowElement size="medium">
                <PaymentStatusBadge
                  status={payment.status}
                  livemode={payment.livemode}
                  error={payment.paymentError}
                  isAbandoned={payment.isAbandoned}
                />
              </TableRowElement>
            );
          })()}
        </>
      )}
    </CardListItem>
  );
};

BookingItem.propTypes = propTypes;

export default BookingItem;
